import './style.css';

const React = () => {

  return(
    <section id="react">
      <h2>O que é React?</h2>
      <p>
         O React (também denominado React.js ou ReactJS) é uma biblioteca JavaScript de código aberto com foco em criar interfaces de usuário (frontend) em páginas web. É mantido pelo Facebook, Instagram, outras empresas e uma comunidade de desenvolvedores individuais. É utilizado nos sites da Netflix, Imgur, Feedly, Airbnb, SeatGeek, HelloSign, Walmart e outros.
      </p>
    </section>
  )
}

export default React;